import { api } from "./client";
import type { Note } from "@/lib/types/inventory";

export function getNotes(params: { entityType: string; entityId: string }) {
  return api.get<{ data: Note[] }>("/notes", { params });
}

export function createNote(data: {
  entityType: string;
  entityId: string;
  content: string;
}) {
  return api.post<{ data: Note }>("/notes", data);
}

export function updateNote(id: string, data: { content: string }) {
  return api.patch<{ data: Note }>(`/notes/${id}`, data);
}

export function deleteNote(id: string) {
  return api.delete(`/notes/${id}`);
}
